import { observer } from 'mobx-react';
import { IPointAccordionWrapper } from '~views/marketing-page/benefits-rewards/IBenefitsRewards';
import { BenefitsRewardsItem } from '~views/marketing-page/benefits-rewards/BenefitsRewardsItem';
import * as React from 'react';
import styled from 'styled-components';
import { Accordion, LabelDetailSlide } from '@estee/elc-accordion';
import { classes } from '~utils/Classes';

const benefitsRewardsAccordionClass = classes('loyalty-marketing-page-benefits-rewards__accordion');
const benefitsRewardsLabelSlideClass = classes(
    'loyalty-marketing-page-benefits-rewards__labelSlide'
);
const benefitsRewardsUlClass = classes('loyalty-marketing-page-benefits-rewards__list');

const PointAccordion = styled(Accordion)`
    grid-area: MarketingPageBenefitsRewardsAccordion;
`;
const PointLabelDetailSlide = styled(LabelDetailSlide)`
    grid-area: MarketingPageBenefitsRewardsDetailSlide;
`;

export const BenefitsRewardsPointAccordionWrapper = observer(function PointAccordionWrapper({
    mapOfItems,
    textColor,
    sign
}: IPointAccordionWrapper) {
    return (
        <PointAccordion className={benefitsRewardsAccordionClass}>
            {mapOfItems.map((item, index) => (
                <PointLabelDetailSlide
                    className={benefitsRewardsLabelSlideClass}
                    id={item.benefits.key}
                    title={item.benefits.heading}
                    extrainfo={item.benefits.shortDescription}
                    iconType="arrow"
                    key={index}
                    headerBackgroundColor={item.benefits.levelColor?.hex}
                >
                    <ul className={benefitsRewardsUlClass} key={item.benefits.heading}>
                        {item.labels.map((label) => (
                            <BenefitsRewardsItem
                                key={label.key}
                                tier={index + 1}
                                tierColor={item.benefits.levelColor}
                                textColor={textColor}
                                sign={sign}
                                heading={label.heading}
                                subHeading={label.subHeading}
                            />
                        ))}
                    </ul>
                </PointLabelDetailSlide>
            ))}
        </PointAccordion>
    );
});
